const desktopHoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
const desktopLayoutQuery = window.matchMedia('(min-width: 990px)');
const footerMenuMediaQuery = window.matchMedia('(max-width: 760px)');
const drawerObservers = new Map();
const drawerContentObservers = new Map();

function closeAllMegaMenus(except) {
  for (const menu of document.querySelectorAll('[data-bcs-mega][open]')) {
    if (menu !== except) menu.removeAttribute('open');
  }
}

function closeAllBenefitDetails(except) {
  for (const detail of document.querySelectorAll('.bcs-benefit__more[open]')) {
    if (detail !== except) detail.removeAttribute('open');
  }
}

function positionBenefitDetail(detail) {
  if (detail.matches('.bcs-ingredient-formula__more')) return;
  const summary = detail.querySelector('summary');
  const content = detail.querySelector('.bcs-benefit__more-content');
  if (!detail.open || !summary || !content) return;

  const viewportPadding = 12;
  const detailRect = detail.getBoundingClientRect();
  const summaryRect = summary.getBoundingClientRect();
  detail.classList.remove('bcs-benefit__more--below');
  let contentRect = content.getBoundingClientRect();
  if (contentRect.top < viewportPadding) {
    detail.classList.add('bcs-benefit__more--below');
    contentRect = content.getBoundingClientRect();
  }
  const summaryCenter = summaryRect.left + summaryRect.width / 2;
  const maxLeft = Math.max(viewportPadding, window.innerWidth - contentRect.width - viewportPadding);
  const viewportLeft = Math.min(Math.max(summaryCenter - contentRect.width / 2, viewportPadding), maxLeft);
  const relativeLeft = viewportLeft - detailRect.left;
  const arrowLeft = Math.min(Math.max(summaryCenter - viewportLeft - 6, 10), contentRect.width - 22);

  content.style.setProperty('--bcs-tooltip-left', `${relativeLeft}px`);
  content.style.setProperty('--bcs-tooltip-shift', '0px');
  content.style.setProperty('--bcs-tooltip-arrow-left', `${arrowLeft}px`);
}

function positionOpenBenefitDetails() {
  for (const detail of document.querySelectorAll('.bcs-benefit__more[open]')) {
    positionBenefitDetail(detail);
  }
}

function setupBenefitDetails(root = document) {
  for (const detail of root.querySelectorAll('.bcs-benefit__more')) {
    if (detail.dataset.bcsBenefitMoreReady === 'true') continue;
    detail.dataset.bcsBenefitMoreReady = 'true';

    detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      closeAllBenefitDetails(detail);
      window.requestAnimationFrame(() => positionBenefitDetail(detail));
    });

    const benefit = detail.closest('.bcs-benefit');
    benefit?.addEventListener('click', (event) => {
      if (!(event.target instanceof Element) || event.target.closest('.bcs-benefit__more')) return;
      detail.open = !detail.open;
      if (detail.open) {
        closeAllBenefitDetails(detail);
        window.requestAnimationFrame(() => positionBenefitDetail(detail));
      }
    });
  }
}

function syncMegaBackdrop() {
  const backdrop = document.querySelector('[data-bcs-mega-backdrop]');
  if (!backdrop) return;
  const hasOpenDesktopMenu =
    desktopHoverQuery.matches && Boolean(document.querySelector('#header-component [data-bcs-mega][open]'));
  backdrop.setAttribute('aria-hidden', String(!hasOpenDesktopMenu));
  backdrop.classList.toggle('bcs-mega-backdrop--visible', hasOpenDesktopMenu);
}

function setupMegaMenus(root = document) {
  const menus = [...root.querySelectorAll('[data-bcs-mega]')];
  if (!menus.length) return;
  const backdrop = document.querySelector('[data-bcs-mega-backdrop]');

  for (const menu of menus) {
    if (menu.dataset.bcsMegaReady === 'true') continue;
    menu.dataset.bcsMegaReady = 'true';
    let closeTimer;
    const item = menu.closest('.bcs-mega-item');
    const trigger = menu.querySelector(':scope > summary');

    item?.addEventListener('pointerenter', () => {
      if (!desktopHoverQuery.matches) return;
      window.clearTimeout(closeTimer);
      menu.open = true;
    });

    item?.addEventListener('pointerleave', () => {
      if (!desktopHoverQuery.matches) return;
      closeTimer = window.setTimeout(() => menu.removeAttribute('open'), 120);
    });

    trigger?.addEventListener('click', (event) => {
      if (desktopHoverQuery.matches && event.detail > 0) event.preventDefault();
    });

    menu.addEventListener('toggle', () => {
      if (menu.open) closeAllMegaMenus(menu);
      syncMegaBackdrop();
    });
  }

  if (backdrop && backdrop.dataset.bcsMegaBackdropReady !== 'true') {
    backdrop.dataset.bcsMegaBackdropReady = 'true';
    backdrop.addEventListener('click', () => {
      closeAllMegaMenus();
      syncMegaBackdrop();
    });
  }
  syncMegaBackdrop();
}

function setupMobileDrawers(root = document) {
  const drawers = [...root.querySelectorAll('[data-bcs-mobile-drawer]')];

  for (const drawer of drawers) {
    if (drawer.dataset.bcsMobileDrawerReady === 'true') continue;
    drawer.dataset.bcsMobileDrawerReady = 'true';

    const host = drawer.closest('header-drawer');
    const details = drawer.closest('details');
    const syncDynamicContent = () => {
      const viewsContainer = drawer.querySelector('.mobile-drawer__views');
      const mobileItemSlot = drawer.querySelector('[data-bcs-mobile-drawer-items-slot]');
      const mobileItemSources = [...drawer.querySelectorAll('[data-bcs-mobile-drawer-item-source]')];

      if (mobileItemSlot && viewsContainer && mobileItemSources.length) {
        for (const fallbackItem of drawer.querySelectorAll('[data-bcs-mobile-menu-fallback]')) {
          fallbackItem.remove();
        }

        for (const source of mobileItemSources) {
          const template =
            source instanceof HTMLTemplateElement
              ? source
              : source.querySelector('[data-bcs-mobile-drawer-item-template]');
          if (!(template instanceof HTMLTemplateElement)) continue;

          const content = template.content.cloneNode(true);
          const navItem = content.querySelector(
            '[data-bcs-mobile-drawer-item-nav], [data-bcs-mobile-drawer-item-link]'
          );
          const inlineItem = content.querySelector('[data-bcs-mobile-drawer-item-inline]');
          const itemView = content.querySelector('[data-bcs-mobile-drawer-item-view]');
          const itemKey = (navItem || inlineItem)?.dataset.bcsMobileDrawerItemKey;
          const targetName = navItem?.dataset.bcsDrawerTarget;
          const existingNavItem = [
            ...drawer.querySelectorAll(
              '[data-bcs-mobile-drawer-item-nav], [data-bcs-mobile-drawer-item-link]'
            ),
          ].find((item) => item.dataset.bcsMobileDrawerItemKey === itemKey);
          const existingItemView = [...drawer.querySelectorAll('[data-bcs-mobile-drawer-item-view]')].find(
            (view) => view.dataset.bcsDrawerView === targetName
          );
          const existingInlineItem = [...drawer.querySelectorAll('[data-bcs-mobile-drawer-item-inline]')].find(
            (item) => item.dataset.bcsMobileDrawerItemKey === itemKey
          );

          if (navItem && !existingNavItem) {
            mobileItemSlot.before(navItem);
          } else if (navItem && existingNavItem && !existingNavItem.isEqualNode(navItem)) {
            existingNavItem.replaceWith(navItem);
          }

          if (inlineItem && !existingInlineItem) {
            mobileItemSlot.before(inlineItem);
          } else if (inlineItem && existingInlineItem && !existingInlineItem.isEqualNode(inlineItem)) {
            existingInlineItem.replaceWith(inlineItem);
          }

          if (itemView && !existingItemView) {
            viewsContainer.append(itemView);
          } else if (itemView && existingItemView && !existingItemView.isEqualNode(itemView)) {
            if (existingItemView.classList.contains('mobile-drawer__view--active')) {
              itemView.classList.add('mobile-drawer__view--active');
              itemView.setAttribute('aria-hidden', 'false');
            }
            existingItemView.replaceWith(itemView);
          }
        }
      }

    };

    syncDynamicContent();

    const showView = (name, focusView = true) => {
      let activeView;

      for (const view of drawer.querySelectorAll('[data-bcs-drawer-view]')) {
        const isActive = view.dataset.bcsDrawerView === name;
        view.classList.toggle('mobile-drawer__view--active', isActive);
        view.setAttribute('aria-hidden', String(!isActive));
        if (isActive) {
          activeView = view;
          view.scrollTop = 0;
        }
      }

      if (focusView) {
        activeView?.focus({ preventScroll: true });
      }
    };

    drawer.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const target = event.target.closest('[data-bcs-drawer-target]');
      if (target) {
        event.preventDefault();
        const productTitle = drawer.querySelector('[data-bcs-drawer-product-title]');
        if (target.dataset.bcsDrawerTitle && productTitle) {
          productTitle.textContent = target.dataset.bcsDrawerTitle;
        }
        showView(target.dataset.bcsDrawerTarget);
        return;
      }

      if (event.target.closest('[data-bcs-drawer-back]')) {
        event.preventDefault();
        showView('main');
        return;
      }

      const link = event.target.closest('a[href]');
      if (link && link.getAttribute('href') !== '#') host?.close?.();
    });

    drawer.addEventListener(
      'keyup',
      (event) => {
        if (event.key !== 'Escape') return;
        const activeView = drawer.querySelector('.mobile-drawer__view--active');
        if (!activeView || activeView.dataset.bcsDrawerView === 'main') return;

        event.preventDefault();
        event.stopImmediatePropagation();
        showView('main');
      },
      true
    );

    if (details) {
      const observer = new MutationObserver(() => {
        if (!details.hasAttribute('open')) showView('main', false);
        syncMegaBackdrop();
      });
      observer.observe(details, { attributes: true, attributeFilter: ['open'] });
      drawerObservers.set(drawer, observer);
      syncMegaBackdrop();
    }

    if (!drawerContentObservers.has(drawer)) {
      let syncScheduled = false;
      const contentObserver = new MutationObserver(() => {
        if (syncScheduled) return;
        syncScheduled = true;
        requestAnimationFrame(() => {
          syncScheduled = false;
          syncDynamicContent();
        });
      });
      contentObserver.observe(drawer, { childList: true, subtree: true });
      drawerContentObservers.set(drawer, contentObserver);
    }
  }
}

function setupFooterMenus(root = document) {
  const menus = [...root.querySelectorAll('[data-bcs-footer-menu]')];
  if (!menus.length) return;

  for (const [index, menu] of menus.entries()) {
    if (footerMenuMediaQuery.matches) {
      if (menu.dataset.bcsFooterMode !== 'mobile') menu.open = index === 0;
      menu.dataset.bcsFooterMode = 'mobile';
    } else {
      menu.open = true;
      menu.dataset.bcsFooterMode = 'desktop';
    }
  }
}

function closeMobileDrawersOnDesktop() {
  if (!desktopLayoutQuery.matches) return;

  for (const drawer of document.querySelectorAll('header-drawer')) {
    const details = drawer.querySelector(':scope > details');
    if (!details?.hasAttribute('open')) continue;

    if (typeof drawer.close === 'function') {
      drawer.close();
    } else {
      details.removeAttribute('open');
      details.classList.remove('menu-open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    }
  }
}

setupMegaMenus();
setupMobileDrawers();
setupFooterMenus();
setupBenefitDetails();

desktopHoverQuery.addEventListener?.('change', syncMegaBackdrop);
desktopLayoutQuery.addEventListener?.('change', () => {
  closeMobileDrawersOnDesktop();
  syncMegaBackdrop();
});
footerMenuMediaQuery.addEventListener?.('change', () => setupFooterMenus());
window.addEventListener('resize', positionOpenBenefitDetails);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openBenefit = document.querySelector('.bcs-benefit__more[open]');
  if (openBenefit) {
    openBenefit.removeAttribute('open');
    openBenefit.querySelector('summary')?.focus();
    return;
  }
  const openMenu = document.querySelector('[data-bcs-mega][open]');
  if (!openMenu) return;
  openMenu.removeAttribute('open');
  openMenu.querySelector('summary')?.focus();
});

document.addEventListener('click', (event) => {
  for (const detail of document.querySelectorAll('.bcs-benefit__more[open]')) {
    if (!detail.closest('.bcs-benefit')?.contains(event.target)) detail.removeAttribute('open');
  }

  const openMenus = document.querySelectorAll('[data-bcs-mega][open]');
  if (!openMenus.length) return;
  for (const menu of openMenus) {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  }
});

document.addEventListener('shopify:section:load', (event) => {
  setupMegaMenus(event.target);
  setupMobileDrawers(event.target);
  setupFooterMenus(event.target);
  setupBenefitDetails(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  if (!(event.target instanceof Element)) return;
  for (const drawer of event.target.querySelectorAll('[data-bcs-mobile-drawer]')) {
    drawerObservers.get(drawer)?.disconnect();
    drawerObservers.delete(drawer);
    drawerContentObservers.get(drawer)?.disconnect();
    drawerContentObservers.delete(drawer);
  }
});
